import React from 'react';
import Widget from '../Widget/Widget.js'
import './ImageWidget.css'

class ImageWidget extends React.Component {

  render() {

    var widgetHeight = (this.props.rowHeight*this.props.size.h) - 40

    var style = {
      maxHeight:widgetHeight+"px"
    }

    var title;

    if(this.props.title && this.props.title !== "") {
      widgetHeight = (this.props.rowHeight*this.props.size.h) - 120
      title = (<h1 className="text-center">{this.props.title}</h1>)
      style.maxHeight = widgetHeight+"px";
      style.paddingTop = "0px";
    }



    return (
      <Widget {...this.props}>
        <div className="row widget-fullheight-row">
          <div className="col align-self-center">
            <div>
              {title}
              <img src={this.props.imageUrl} className="img-fluid mx-auto d-block image-widget" alt={this.props.name} style={style}/>
            </div>
          </div>
        </div>
      </Widget>
    )
  }
}

export default ImageWidget;



// WEBPACK FOOTER //
// ./src/components/Dashboard/components/ImageWidget/ImageWidget.js